import { useAtomValue } from 'jotai';
import { useCallback, useMemo } from 'react';
import { userPermissions } from 'store/public/userPermissions';

import { buildPermissionSet, checkList } from './permissions';

export const usePermissions = () => {
  const { permissions = [], isReady } = useAtomValue(userPermissions);

  const permissionSet = useMemo(
    () => buildPermissionSet(permissions),
    [permissions],
  );

  const can = useCallback(
    permission => {
      if (!isReady || !permission) {
        return false;
      }

      return permissionSet.has(permission);
    },
    [isReady, permissionSet],
  );

  const canAny = useCallback(
    (permissionList = []) => {
      if (!isReady) {
        return false;
      }

      return checkList({
        values: permissionList,
        mode: 'any',
        checker: permission => permissionSet.has(permission),
      });
    },
    [isReady, permissionSet],
  );

  const canAll = useCallback(
    (permissionList = []) => {
      if (!isReady) {
        return false;
      }

      return checkList({
        values: permissionList,
        mode: 'all',
        checker: permission => permissionSet.has(permission),
      });
    },
    [isReady, permissionSet],
  );

  return {
    isReady,
    permissions,

    can,
    canAny,
    canAll,
  };
};
